import React from 'react';
import { Select, SelectProps } from 'antd';
import { SelectInput, SelectInputProps } from '../form';

export enum Timezone {
  AustraliaAdelaide = 'Australia/Adelaide',
  AustraliaBrisbane = 'Australia/Brisbane',
  AustraliaDarwin = 'Australia/Darwin',
  AustraliaHobart = 'Australia/Hobart',
  AustraliaPerth = 'Australia/Perth',
  AustraliaSydney = 'Australia/Sydney',
}

export const getTimezoneDisplay = (tz: Timezone | string) => {
  switch (tz) {
    case Timezone.AustraliaAdelaide:
      return 'Adelaide';
    case Timezone.AustraliaBrisbane:
      return 'Brisbane';
    case Timezone.AustraliaDarwin:
      return 'Darwin';
    case Timezone.AustraliaHobart:
      return 'Hobart';
    case Timezone.AustraliaPerth:
      return 'Perth';
    case Timezone.AustraliaSydney:
      return 'Canberra, Melbourne, Sydney';
    default:
      return tz;
  }
};

const tzStrings = [
  { value: 'Australia/Perth', label: 'Perth' },
  { value: 'Australia/Adelaide', label: 'Adelaide' },
  { value: 'Australia/Darwin', label: 'Darwin' },
  { value: 'Australia/Brisbane', label: 'Brisbane' },
  {
    value: 'Australia/Sydney',
    label: 'Canberra, Melbourne, Sydney',
  },
  { value: 'Australia/Hobart', label: 'Hobart' },
];

export interface ITZProps extends SelectProps {
  name: string;
  disabled?: boolean;
  onChange?: (value: any, option: any) => void;
}

const TzDropdown = (props: ITZProps) => {
  const options = tzStrings.map((i) => (
    <Select.Option key={i.value} value={i.value}>
      {i.label}
    </Select.Option>
  ));

  const handleChange = (value: any, option: any) => {
    if (props.onChange) props.onChange(value, option);
  };

  return (
    <div className="relative">
      <Select {...props} onChange={handleChange} getPopupContainer={(trigger) => trigger.parentElement}>
        {options}
      </Select>
    </div>
  );
};

// TODO: Remove it soon
export default TzDropdown;

export function TimezoneDropdown(props: Omit<SelectInputProps<Timezone>, 'options'>) {
  const options = [
    { value: Timezone.AustraliaAdelaide, display: getTimezoneDisplay(Timezone.AustraliaAdelaide) },
    { value: Timezone.AustraliaBrisbane, display: getTimezoneDisplay(Timezone.AustraliaBrisbane) },
    { value: Timezone.AustraliaDarwin, display: getTimezoneDisplay(Timezone.AustraliaDarwin) },
    { value: Timezone.AustraliaHobart, display: getTimezoneDisplay(Timezone.AustraliaHobart) },
    { value: Timezone.AustraliaPerth, display: getTimezoneDisplay(Timezone.AustraliaPerth) },
    { value: Timezone.AustraliaSydney, display: getTimezoneDisplay(Timezone.AustraliaSydney) },
  ];
  return <SelectInput {...props} options={options} />;
}
